import { io, ManagerOptions, Socket, SocketOptions } from 'socket.io-client';

const SOCKET_URL = process.env.EXPO_PUBLIC_API_URL;

export const socketConfig: Partial<ManagerOptions & SocketOptions> = {
  path: '/live',
  transports: ['websocket'],
  reconnection: false,
  auth: {},
  forceNew: false,
  autoConnect: false,
  withCredentials: true,
  timeout: 7000,
  secure: true,
};

export const socket: Socket = io(SOCKET_URL, socketConfig);
